import { AdminCheckContainer } from "../../containers/borrowSystem/AdminCheckContainer";

export function AdminCheckPage() {
    return (
        <AdminCheckContainer />
    )
}
